import React from "react";
import "./login.scss";
import { Alert, Modal } from "react-bootstrap";
import { BtnNext } from "../../bouton/btn-next";
import UseSigninCtr from "./useLogin";

type IModalLoginProps = {
  show: boolean;
  setShow: (a: boolean) => void;
  messageText: string;
  callBackFunction: any;
};

export default function LoginModal(props: IModalLoginProps) {
  const {
    error,
    showLoader,
    password,
    showPassword,
    checkPassword,
    setPassword,
    setShowPasswpord,
  } = UseSigninCtr(props?.callBackFunction);

  return (
    <Modal
      show={props.show}
      className="createCompanypopup large forStep5custom logincomp"
    >
      <Modal.Header>
        <div className="headerpopupCompany noStep">
          <h2 className="title">Input password</h2>
          <a
            href="javascript:;"
            className="close"
            onClick={() => props.setShow(false)}
          >
            <span className="icon-close-pop"></span>
          </a>
        </div>
      </Modal.Header>
      <Modal.Body className="">
        <div className="loginContent">
          <div className="col-12">
            <span className="labeled">{props?.messageText}</span>
          </div>
          <form action="" className="loginForm">
            {error && <Alert variant="danger">Bad credentials</Alert>}
            <div className="form-group passwordContent">
              <input
                type={showPassword ? "text" : "password"}
                name=""
                id=""
                placeholder="Password"
                className="input password"
                value={password}
                onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
                  setPassword(event.target.value)
                }
              />
              <span
                className="showPassWord"
                onClick={() => setShowPasswpord(!showPassword)}
              >
                Show
              </span>
            </div>
            <div className="loginbtncontent">
              <div className="btn btn-devinsider large containerBtnBtn">
                <BtnNext
                  text={"Continue"}
                  click={(): void => checkPassword()}
                  showLoader={showLoader}
                />
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}
